import styled from 'styled-components'

import { SPACING as constants } from '../../constants'

/** @param {{ topic?: string }} props */
const topic = props => props.topic || 'Topic'

const Card = styled.div`
  padding-top: 50px;
  position: relative;

  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  &::before {
    content: '${topic}';
    width: 100%;
    height: 50px;
    padding-left: ${constants.GAP};

    background-color: #404040;

    display: flex;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;

    color: #fff;
    font-family: 'Gotham-Medium';
    font-size: 15px;
  }
`

export default Card



// WEBPACK FOOTER //
// ./src/lib/components/Card.jsx